<template>
  <validation-observer ref="simpleRules">
    <product-files-item-form />
    <save-button
      :save-action="submitForm"
      :is-disabled="uploading"
    />
  </validation-observer>
</template>

<script>

import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import ProductFilesItemForm from '@/views/Products/Files/ItemForm.vue'

export default {
  name: 'Add',
  components: {
    ProductFilesItemForm,
    ValidationObserver,
    SaveButton,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    uploading() {
      return this.$store.getters['productFiles/uploading']
    },
    dataItem() {
      return this.$store.getters['productFiles/dataItem']
    },
    saveData() {
      return this.$store.getters['productFiles/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.$router.push(`/app/products/edit/${this.$route.params.id}`)
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    localize('tr')
    this.$store.dispatch('productFiles/resetDataItem')
  },
  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.dataItem.id_products = this.$route.params.id
          this.$store.dispatch('productFiles/saveData', this.dataItem)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
